<template>
  <div class="invoice-tax-rate-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备名称：</span>
        </div>
        <el-input v-model="formData.deviceName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="formData.deviceCode" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备厂商：</span>
        </div>
        <el-select v-model="formData.deviceManufacturerCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备型号：</span>
        </div>
        <el-select v-model="formData.deviceModelCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceModelList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">所属楼栋：</span>
        </div>
        <el-select v-model="formData.buildingCode" size="small" style="width: 280px">
          <el-option v-for="item in buildingList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">所属楼层：</span>
        </div>
        <el-select v-model="formData.floorCode" size="small" style="width: 280px">
          <el-option v-for="item in floorList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">是否启用关联设备：</span>
        </div>
        <el-switch
          v-model="enableAssociatedActionState"
          active-text="启用"
          inactive-text="不启用">
        </el-switch>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">关联门禁：</span>
        </div>
        <el-select v-model="accessDeviceCodeList" multiple size="small" style="width: 280px">
          <el-option v-for="item in accessDeviceList" :key="item.deviceCode"
                     :label="item.deviceName" :value="item.deviceCode">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">关联梯控：</span>
        </div>
        <el-select v-model="liftDeviceCodeList" multiple size="small" style="width: 280px">
          <el-option v-for="item in liftDeviceList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../../api/FireControl'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {errorHandler} from '../../../../utils/errorHandler'
  import UploadImgList from '../../../../components/Input/UploadImgList'

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'smoke-sensation-device-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧消防',
          name: 'fire-over-view'
        }, {
          value: '烟感设备'
        }],
        mainTitle: '添加烟感设备',
        subheading: '',

        buildingList: [],
        floorList: [],

        deviceManufacturerList: [
          {
            code: '大麦',
            name: '大麦'
          }
        ],

        deviceModelList: [
          {
            code: 'DM-FC-S001',
            name: 'DM-FC-S001'
          }
        ],

        gatewayDeviceList: [],

        enableAssociatedActionState: false,
        accessDeviceCodeList: [],
        liftDeviceCodeList: [],
        formData: {
          deviceName: '',
          deviceCode: '',
          deviceType: '2',
          deviceManufacturerName: '',
          deviceManufacturerCode: '大麦',
          deviceModelName: '',
          deviceModelCode: 'DM-FC-S001',
          floorName: '',
          floorCode: '',
          buildingName: '',
          buildingCode: '',
          enableAssociatedActions: '0',
          accessDeviceList: [],
          liftDeviceList: []
        },

        accessDeviceList: [],
        liftDeviceList: []
      }
    },
    created () {
      this.getBuildingList()
      this.getAccessDeviceList()
      this.getLiftDeviceList()
    },
    methods: {
      // 获取楼栋列表
      getBuildingList () {
        this.$axios.post(api.getBuildingList, {})
          .then(res => {
            this.buildingList = res.data.data
          })
          .catch(errorHandler('获取楼栋列表失败'))
      },
      // 获取门禁列表
      getAccessDeviceList () {
        this.$axios.post(api.getAccessDeviceList, {})
          .then(res => {
            this.accessDeviceList = res.data.data
          })
          .catch(errorHandler('获取门禁列表失败'))
      },
      // 获取梯控列表
      getLiftDeviceList () {
        this.$axios.post(api.getLiftDeviceList, {})
          .then(res => {
            this.liftDeviceList = res.data.data
          })
          .catch(errorHandler('获取梯控列表失败'))
      },
      // 获取网关列表
      getGatewayDeviceList () {
        this.$axios.post(api.getGatewayDeviceList, {})
          .then(res => {
            this.gatewayDeviceList = res.data.data
          })
          .catch(errorHandler('获取网关列表失败'))
      },

      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },

      toManagePage () {
        this.$router.push({
          name: 'smoke-sensation-device-manage'
        })
      },

      confirm () {
        if (!this.formData.deviceName) {
          nError('请输入设备名称')
          return false
        }
        if (!this.formData.deviceCode) {
          nError('请输入设备编号')
          return false
        }
        this.formData.accessDeviceList = []
        this.formData.liftDeviceList = []
        this.deviceManufacturerList.map(v => {
          if (v.code === this.formData.deviceManufacturerCode) {
            this.formData.deviceManufacturerName = v.name
          }
        })
        this.deviceModelList.map(v => {
          if (v.code === this.formData.deviceModelCode) {
            this.formData.deviceModelName = v.name
          }
        })
        this.gatewayDeviceList.map(v => {
          if (v.deviceCode === this.formData.parentCode) {
            this.formData.parentName = v.deviceName
          }
        })
        this.gatewayDeviceList.map(v => {
          if (v.deviceCode === this.formData.parentCode) {
            this.formData.parentName = v.deviceName
          }
        })
        this.buildingList.map(v => {
          if (v.code === this.formData.buildingCode) {
            this.formData.buildingName = v.name
          }
        })
        this.floorList.map(v => {
          if (v.code === this.formData.floorCode) {
            this.formData.floorName = v.name
          }
        })
        if (this.enableAssociatedActionState) {
          this.formData.enableAssociatedActions = '1'
        } else {
          this.formData.enableAssociatedActions = '0'
        }
        this.accessDeviceList.map(v => {
          if (this.accessDeviceCodeList.indexOf(v.deviceCode) !== -1) {
            this.formData.accessDeviceList.push(v)
          }
        })
        this.liftDeviceList.map(v => {
          if (this.liftDeviceCodeList.indexOf(v.code) !== -1) {
            this.formData.liftDeviceList.push(v)
          }
        })
        this.$axios.post(api.addFireSmokeDevice, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.toManagePage()
      }
    },
    watch: {
      'formData.buildingCode': {
        handler(newName, oldName) {
          this.buildingList.map(v => {
            if (v.code === this.formData.buildingCode) {
              this.floorList = v.floors
            }
          })
        },
        deep: true
      },
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 140px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 28px;
    line-height: 40px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .invoice-tax-rate-add {
    .el-switch {
      height: 30px;
    }
    .el-input-number.is-controls-right .el-input__inner {
      text-align: left;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/FireControl/FireControlDeviceManage/SmokeSensationDeviceManage/SmokeSensationDeviceAdd.vue